import { Stack, Flex, Text, Box } from '@chakra-ui/core'

import React, { useState } from 'react'
import { BtnTextField } from '../fileds/BtnTextField'
import { BodyField } from '../fileds/BodyField'
import { PopSwitch } from '../fileds/PopSwitch'
import { PushTitleField } from '../fileds/PushTitleField'
import { PopRecipients } from '../fileds/PopRecipients'
import { TitleField } from '../fileds/TitleField'
import { UploadMediaSection } from '../fileds/UploadMediaSection'
import { ProfileImageField } from '../fileds/ProfileImageField'
import { PushMessageField } from '../fileds/PushMessageField'
import { RePopRecipient } from '../fileds/RepopRecipient'
import { PopFormValues, PopType } from 'components/PopCreation/types'
import { Controller, useFormContext } from 'react-hook-form'
import useLocaleText from 'components/useLocaleText'

export const RePOPForm = ({ isEdit }: { isEdit: boolean }) => {
  const { control } = useFormContext<PopFormValues>()
  const pick_audience = useLocaleText('pick_audience')
  const select_recipient = useLocaleText('select_recipient', true)
  const enable_push_notification = useLocaleText('enable_push_notification', true)
  const enable_repop_push_notification = useLocaleText('enable_repop_push_notification', true)
  const [isCustomAvatar, setIsCustomAvatar] = useState(false)

  return (
    <Stack style={{ gap: '15px' }}>
      <Stack style={{ gap: '10px' }} mt={4}>
        <ProfileImageField
          isCustomAvatarOption
          isCustomAvatar={isCustomAvatar}
          setIsCustomAvatar={setIsCustomAvatar}
          isEdit={isEdit}
        />
        <TitleField />
        <BodyField keyName="data.pop_body" label="pop_body" placeholder="pop_body_placeholder" />
        <BtnTextField keyName="data.ack_btn_text" label="ack_btn" placeholder="ack_btn_placeholder" />
      </Stack>

      <Box>
        <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2}>
          {pick_audience}
        </Text>
        <PopRecipients groupsKey="data.repop_groups" usersKey="data.repop_users" tagsKey="data.repop_tags" />
      </Box>

      <Box>
        <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2}>
          {select_recipient}
        </Text>
        <RePopRecipient isCustomAvatar={isCustomAvatar} />

        <Flex
          alignItems="center"
          flexDir={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          w="100%"
          mt={2}
          style={{ gap: '10px' }}
        >
          <Box w="100%" h="97px">
            <BtnTextField
              keyName="data.repop_main_btn"
              label="repop_main_btn"
              placeholder="repop_main_btn_placeholder"
            />
          </Box>
          <Box w="100%" h="97px">
            <BtnTextField keyName="data.repop_sec_btn" label="repop_sec_btn" placeholder="repop_sec_btn_placeholder" />
          </Box>
        </Flex>
      </Box>

      <UploadMediaSection />

      <Flex
        alignItems="center"
        flexDir={{ base: 'column', md: 'row' }}
        justifyContent="space-between"
        mt={2}
        w="100%"
        style={{ gap: '20px' }}
      >
        <Box w="100%">
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2} w="100%">
              {enable_push_notification}
            </Text>
            <PopSwitch name="is_send_push_notification" />
          </Flex>

          <Box>
            <PushTitleField
              keyName="data.push_title"
              label="push_title"
              placeholder="push_title_placeholder"
              keySwitch="is_send_push_notification"
            />
            <PushMessageField
              keyName="data.push_body"
              label="push_body"
              placeholder="push_body_placeholder"
              keySwitch="is_send_push_notification"
            />
          </Box>
        </Box>

        <Box w="100%">
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2} w="100%">
              {enable_repop_push_notification}
            </Text>
            <PopSwitch name="data.is_repop_send_push_notification" />
          </Flex>

          <Box>
            <PushTitleField
              keyName="data.repop_push_title"
              label="repop_push_title"
              placeholder="repop_push_title_placeholder"
              keySwitch="data.is_repop_send_push_notification"
            />
            <PushMessageField
              keyName="data.repop_push_body"
              label="repop_push_body"
              placeholder="repop_push_body_placeholder"
              keySwitch="data.is_repop_send_push_notification"
            />
          </Box>
        </Box>
      </Flex>
      <Controller name="pop_type" control={control} defaultValue={PopType.RePop} as={<Box display="none" />} />
      <Controller name="rid" control={control} as={<Box display="none" />} />
    </Stack>
  )
}
